export const parseAutoVerifyInterval = (hours, minutes, seconds) => {
  const parts = [hours, minutes, seconds].map(value => {
    if (String(value).trim() === '') return 0;
    return Number(value);
  });
  if (parts.some(value => !Number.isInteger(value) || value < 0)
    || parts[0] > 24 || parts[1] > 59 || parts[2] > 59) {
    throw new Error('Enter whole numbers: hours 0-24, minutes 0-59, and seconds 0-59.');
  }
  const total = parts[0] * 3600 + parts[1] * 60 + parts[2];
  if (total < 15 || total > 86400) {
    throw new Error('Choose an interval from 15 seconds to 1 day, in whole seconds.');
  }
  return total;
};
